module.exports = __webpack_public_path__ + "static/pokoj-nr5-photo06-2344029a2b712a008232a604e6a2d8bf.jpg";